import { NotesPanelState } from '../../helpers/notesPanel'
import { IRootState } from '../reducer'
import { prefix } from './actions'

export const notesPanelState = (state: IRootState): NotesPanelState => state[prefix].notesPanelState
// Derived from the panel state so the ~15 existing consumers keep the same
// selector while the underlying model gains rail/hidden states.
export const isNotesShown = (state: IRootState) =>
  state[prefix].notesPanelState === NotesPanelState.docked
export const notesPanelForcedTab = (state: IRootState) => state[prefix].notesPanelForcedTab
// The forced latch and the tab it asked for are one field: a force-open always names
// a tab, so a non-null tab *is* the latch. Derived rather than stored so the two can
// never disagree — see `notesPanelForcedTab` in `panelReducers.ts`.
export const notesPanelForced = (state: IRootState) => state[prefix].notesPanelForcedTab !== null
export const notesCount = (state: IRootState) => state[prefix].count
export const notesComposerRequested = (state: IRootState) => state[prefix].notesComposerRequested
export const isLoading = (state: IRootState) => state[prefix].loadingArray.length > 0
export const notes = (state: IRootState) => state[prefix].notes
export const lastListContext = (state: IRootState) => state[prefix].lastListContext
export const arcProgress = (state: IRootState) => state[prefix].arcProgress
